import Logo from "../../components/common/Logo";
import { Button } from "@material-tailwind/react";

import { useOnboardingStore } from "../../store/onboarding/Onboarding";

import Photos from "../onBoarding/Photos";
import Address from "../../components/booking/Address";
import BoatDetails from "../../components/booking/BoatDetails";
import AddFeatures from "../../components/booking/AddFeatures";
import Publish from "../../components/booking/Publish";
import Pricing from "../../components/booking/Pricing";

function CreateBoat() {
  const { selectedTab, stepNumber, totalStep, onBoardingPage } =
    useOnboardingStore();


  return (
    <div className="md:mx-32 mx-6 my-10 ">
      <div className="flex items-center justify-between my-10">
        <Logo />
        <Button variant="outlined" placeholder={undefined}>
          {" "}
          Save and Exit
        </Button>
      </div>
      <h2 className="text-4xl">Welcome</h2>
      <div className="my-10 md:flex md:justify-between items-center">
        <div className="grid grid-cols-3 gap-4 text-2xl text-gray-500">
          {[
            "Create",
            "Address",
            "Features",
            "Photos",
            "Pricing",
            "Publish",
          ].map((tab) => (
            <div
              key={tab}
              className={`relative cursor-pointer ${
                selectedTab === tab ? "text-black" : "text-gray-500"
              }`}
            >
              <p>{tab}</p>
              {selectedTab === tab && (
                <div className="absolute bottom--10 left-1/2 transform -translate-x-1/2 mb-1 h-2 w-2 rounded-full bg-primary"></div>
              )}
            </div>
          ))}
        </div>
        <div className="h-8 w-8 mx-auto md:mx-0 mt-5 md:mt-0 justify-center items-center flex outline outline-4 outline-primary rounded-full p-1">
          <p className="font-light text-xs">{stepNumber}</p>
          <p className="font-semibold text-sm">/{totalStep}</p>
        </div>
      </div>

      {onBoardingPage === "Photos" && <Photos />}
      {onBoardingPage === "Pricing" && <Pricing />}
      {onBoardingPage === "Address" && <Address />}
      {onBoardingPage === "Create" && <BoatDetails />}
      {onBoardingPage === "Features" && <AddFeatures />}
      {onBoardingPage === "Publish" && <Publish />}
    </div>
  );
}

export default CreateBoat;
